"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _r10SourceLibrary = require("r10-source-library");
var _widgetSelectors = require("../../store/widget/widgetSelectors");
var _HeaderTop = _interopRequireDefault(require("../shared/HeaderTop"));
var _BackButton = _interopRequireDefault(require("../shared/BackButton"));
var _useLocalTheme = _interopRequireDefault(require("../../hooks/useLocalTheme"));
var _QuestionHeader = require("../Questionnaire/QuestionHeader");
var _useQuestionnaireNavigation = require("../../hooks/questionnaire/useQuestionnaireNavigation");
var _useAppSelector = require("../../hooks/useAppSelector");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const HeaderWrapper = _styledComponents.default.div`
  display: flex;
  align-items: center;
`;
const HeaderTitleWrapper = _styledComponents.default.div`
  flex: 1;
`;
const getActionComponent = actionBtn => {
  const {
    onRestart,
    onRestartWithWarningMessage
  } = (0, _useQuestionnaireNavigation.useQuestionnaireNavigation)();
  const showRestartWarningMessage = (0, _useLocalTheme.default)('showRestartWarningMessage', false);
  if (actionBtn === 'back') return /*#__PURE__*/_react.default.createElement(_BackButton.default, null);
  if (actionBtn === 'restart') return /*#__PURE__*/_react.default.createElement(_QuestionHeader.RestartBtnComponent, {
    isRestartVisible: true,
    placement: "header",
    onRestart: showRestartWarningMessage ? onRestartWithWarningMessage : onRestart
  });
  return null;
};
const Header = _ref => {
  let {
    id,
    headerText,
    headerTitle,
    headerTextWeight,
    headerTextSize,
    headerSubtitle
  } = _ref;
  const {
    showModalView
  } = (0, _useAppSelector.useAppSelector)(_widgetSelectors.selectUiSettings);
  const showHeaderTitle = (0, _useLocalTheme.default)('recommendation.showHeaderTitle', true);
  const actionComponent = (0, _useLocalTheme.default)('recommendation.actionComponent', 'back');
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, showModalView ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_HeaderTop.default, {
    actionComponent: getActionComponent(actionComponent),
    isCloseButtonHidden: false,
    showDivider: true,
    id: id
  }), showHeaderTitle && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 6,
      bottom: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    appearance: "secondary",
    size: 2,
    justify: 'center',
    weight: 3,
    text: headerText,
    noMargin: true
  })), headerSubtitle && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    appearance: "secondary",
    size: 3,
    justify: 'center',
    weight: 2
  }, headerSubtitle))) : /*#__PURE__*/_react.default.createElement(HeaderWrapper, null, /*#__PURE__*/_react.default.createElement(_BackButton.default, null), /*#__PURE__*/_react.default.createElement(HeaderTitleWrapper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    appearance: "secondary",
    size: 3,
    justify: 'center',
    weight: 1,
    text: headerTitle,
    noMargin: true
  }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    appearance: "secondary",
    size: headerTextSize || 1,
    justify: 'center',
    weight: headerTextWeight || 2,
    text: headerText,
    noMargin: true
  })))));
};
var _default = Header;
exports.default = _default;